<template>
		<div style="padding: 20px 20px 20px 0;">
			<el-button @click="goBack" type="primary">返回</el-button>
			<div class="info">基本信息</div>
			<div class="infos">
				<div style="display: flex;justify-content: space-between;padding: 10px;">
					<div class="infoDetail">
						<div>房间号:{{form.address}}</div>
						<div>缴费户号:{{form.accountNumber}}</div>
						<div>当前余额:{{form.status}}</div>
						<div>当前状态:{{form.nowStatus}}</div>
					</div>
				</div>
			</div>
			<div class="info">账单信息</div>
			
			<el-table  :data="tableData">
				<el-table-column prop="orderNumber" label="订单号"></el-table-column>
				<el-table-column prop="time" label="缴费日期">
					<template slot-scope="{row}">
						{{setTime(row.time)}}
					</template>
				</el-table-column>
				<el-table-column prop="orderNumber" label="缴费区间"></el-table-column>
				<el-table-column prop="money" label="缴费金额"></el-table-column>
				<el-table-column prop="orderNumber" label="缴费模式"></el-table-column>
				<el-table-column prop="paymentMethod" label="支付方式"></el-table-column>
				<el-table-column prop="balance" label="账户余额"></el-table-column>
			</el-table>

		</div>
</template>

<script>
	export default{
		data(){
			return{
				selectForm:{
					info:''
				},
				tableData:[],
				form:{}
			}
		},
		methods:{
			goBack(){
				this.$router.go(-1)
			}
		},
		mounted() {
			this.form=this.$route.params.val
			this.$http.get(`/api/bdWaterElectricityPayment/getOneWEPaymentBill?id=${this.form.id}`).then(res=>{
				console.log(res)
				this.tableData=res.data.data
			}).catch(err=>{
				console.log(err)
			})
			
		}
	}
</script>

<style scoped="scoped">
	.info{
		background-color: #00BFAF;
		padding: 10px ;
		margin: 10px 0;
		color: white;
	}
	.infos{
		width: 100%;
		display: flex;
		justify-content: space-between
	}
	.infos>div{
		width: 30%;
		font-size: 14px;
	}
	.infoDetail>div{
		margin-bottom: 10px;
	}
</style>
